import { CIStatusCapsule, MyIcon } from 'ccs-ui-components';
import { Fragment } from 'react';
import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import SummaryGrid from './SummaryGrid';
import { STATUS_TYPES } from './utility/StatusConstant';
import { ConfigDetailType, GridProps } from './utility/TypeDefs';

import classes from './NestedSummary.module.scss';

const NestedSummary = ({ gridData }: GridProps) => {
  const { t: translate } = useTranslation();

  /**
   * @method renderSummaryStatus
   * @description Render summary status.
   * @param {string} status - Config status
   */
  const renderSummaryStatus = (status: string) => (
    <div className="pill-text">
      <CIStatusCapsule status={status} />
    </div>
  );

  return (
    <div className={`${classes['nested-summary-container']}`}>
      {gridData?.map((data: ConfigDetailType, index) => (
        <Accordion flush className="nested-summary-accordion" key={`nested_summary_accordion_${data?.recordName}`} defaultActiveKey={index === 0 ? `nested_acc_${data?.recordName}` : ''}>
          <Accordion.Item eventKey={`nested_acc_${data?.recordName}`}>
            <Accordion.Header>
              <div>
                <div className={classes['accordion-button']}><MyIcon name="bottonArrowIcon" className="summary-arrow-icon" /></div>
                <span className={classes['config-type-text']}>{data?.recordName}</span>
                {renderSummaryStatus(data?.status)}
              </div>
            </Accordion.Header>
            {
              data?.records
              && (
                <Accordion.Body>
                  {data?.status?.toLocaleLowerCase() === STATUS_TYPES.FAILED && data?.errorMessage
                    && (
                      <div className="nested-error-summary col-xs-12 col-sm-7">
                        <p className="nested-error-title">{translate('journey_import_summary.error_message_title')}</p>
                        <p className="nested-error-message">{`${data?.errorMessage}`}</p>
                      </div>
                    )}
                  {data?.records?.map((config: any) => (
                    <Fragment key={`nested_config_summary_${config?.recordType}`}>
                      <p className="nested-config-type">
                        <span>{config?.recordType}</span>&nbsp;
                        {!!config?.recordsCount
                          && (
                            <span>&#40;{config?.recordsCount}&#41;</span>
                          )}
                      </p>
                      <SummaryGrid gridData={config?.configDetails} recordType={config?.recordType} />
                    </Fragment>
                  ))}
                </Accordion.Body>
              )
            }

          </Accordion.Item>
        </Accordion>

      ))}

    </div>
  );
};

export default NestedSummary;
